import AdminsForm from "../utils/AdminsForm";
import PasswordGenerator from "../utils/PasswordGenerator";

export default class AdminsEdit {

    constructor() {
        this.adminsForm = new AdminsForm();
        this.initializePasswordGeneration();
        //this.bindEvents();
        //window.application.setOnDataChangeListener(this);
    }

    initializePasswordGeneration() {
        $('#generate_admin_password_btn').on('click', () => {
            const password = PasswordGenerator.generate();
            $('#admin_password').val(password);
            $('#admin_password_confirmation').val(password);
            $('#generated_admin_password_display').val(password);
        });
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.adminsForm.onDestroy();
        $('#generate_admin_password_btn').off('click');
    }
}